import SelfReadingPresetDateRolesDTO from 'features/requirements/dtos/SelfReadingPresetDateRolesDTO';
import FormGroup from 'features/shared/forms/components/FormGroup';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { SingleDatePicker } from 'react-dates';
import "react-dates/lib/css/_datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './selfreadingdate.module.scss';
import { useTranslation } from 'react-i18next';

const DATE_FORMAT = "DD.MM.YYYY";

interface Props {
  name: string;
  dates: SelfReadingPresetDateRolesDTO;
  editable: boolean;
  onChange: (date: moment.Moment) => void;
  errors?: Record<string, string>;
}

const SelfReadingDate = ({ dates, editable, name, onChange, errors }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // state
  const [focus, setFocus] = useState(false);
  const [date, setDate] = useState<moment.Moment | null>(null);

  // update date
  useEffect(() => {
    setDate(getPresetDate());
  }, [dates])

  // handlers
  const focusChangeHandler = (arg: { focused: boolean | null }) => {
    let focused = arg.focused ? arg.focused : false;
    setFocus(focused);
  }

  const dateChangeHandler = (date: moment.Moment | null) => {
    setDate(date);

    if (date) {
      onChange(date.startOf('day'));
    }
  }

  // helpers
  const getPresetDate = () => {
    if (dates.presetDate) {
      return moment(dates.presetDate);
    }    

    return null;
  }

  const isOutsideOfRange = (day: moment.Moment) => {
    const minDate = dates.intervalFrom ? moment(dates.intervalFrom).startOf('day') : moment("1900-01-01");
    const maxDate = dates.intervalTo ? moment(dates.intervalTo).endOf('day') : moment("2099-12-31");

    return !day.isBetween(minDate, maxDate);
  }

  // render
  if (editable) {
    return (
      <FormGroup labelText={tLabels("selfReadingDate.selfReadingDate")} inputId={name} validationError={errors ? errors[name] : undefined}>
        <div className={styles.customDateInput}>
          <SingleDatePicker
            id={name}
            date={date}
            onDateChange={dateChangeHandler} 
            focused={focus}
            onFocusChange={focusChangeHandler}
            isOutsideRange={isOutsideOfRange}
            displayFormat={DATE_FORMAT}
            numberOfMonths={1}
            customInputIcon={<FontAwesomeIcon icon="calendar-alt" />}
            placeholder={tLabels("selfReadingDate.setSelfReadingDate")}
            readOnly
            block
            hideKeyboardShortcutsPanel
          />
        </div>
      </FormGroup>
    )   
  } else {
    return null;
  }
}

export default SelfReadingDate;
